/**
 * The start offset of the statement under each Query tab's caret, for entry
 * points that open another surface on "the statement the user is on" without
 * holding that tab's editor — the toolbar Visual button, Ctrl/Cmd+Shift+V and
 * the Command Palette all go through `openVqeFromActiveTab`, which reads this.
 * Without it those three always opened the Visual Query Editor on the FIRST
 * statement of a multi-statement buffer. `QueryEditorTabContent` registers a
 * reader per mounted tab; a tab with no caret statement reports `undefined`.
 */
const readers = new Map<string, () => number | undefined>();

export function registerCursorStatementOffset(tabId: string, read: () => number | undefined): () => void {
  readers.set(tabId, read);
  return () => {
    if (readers.get(tabId) === read) readers.delete(tabId);
  };
}

export function cursorStatementOffset(tabId: string): number | undefined {
  return readers.get(tabId)?.();
}
